export default {
  error: state => state.error,
}
